import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
  if(window){
    // window.console.log=function(){};
    // window.console.warn=function(){};
    // window.console.error=function(){};
    // window.console.time=function(){};
    // window.console.timeEnd=function(){};
  }
}

function loadGoogleMaps(apiKey: string) {
  const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
  let node = document.createElement('script');
  node.src = url;
  node.type = 'text/javascript';
  node.async = true;
  document.getElementsByTagName('head')[0].appendChild(node);
}

function getNotAllowedTenants() {
  return environment.excludingTenants ?? [];
}

function tenants() {
  if (getNotAllowedTenants().includes(1)) {
    return '2';
  } else {
    return '1';
  }
}

function loadScript(apiKey: string) {
  return new Promise((resolve, reject) => {
    const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
    setTimeout(() => {
      resolve(true);
    }, 500)

  });
}

function bootstrap() {
  const tenantId = localStorage.getItem('tenantId');
  fetch(environment.apiEndPoint + '/Auth/TenantConfiguration/GetGoogleKey', {
    method: 'GET',
    headers: {
      'tenantId': tenantId && tenantId !== '' ? tenantId : environment.defaultTenant
    }
  })
    .then((res) => res.json())
    .then((resp) => {
        localStorage.setItem('mapKey', atob(resp.data.key));
        loadScript(atob(resp.data.key)).then(() => {
          platformBrowserDynamic().bootstrapModule(AppModule)
            .catch(err => console.error(err));
        });

      },
      (error) => {
        platformBrowserDynamic()
          .bootstrapModule(AppModule)
          .catch((err) => console.error(err));
      });
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap, {passive: true});
}
